import React from "react";
import HerroSectionAboutUs from "../components/AboutUsPage/HerroSectionAboutUs";
import CompanyTeamSection from "../components/AboutUsPage/CompanyTeamSection";
import SecondSection from "../components/AboutUsPage/SecondSection";
import StaffGallery from "../components/AboutUsPage/StaffGallery";
import SectionProjectsList from "../components/HomePage/SectionProjectsList";

const AboutCompany = () => {
  return (
    <div className="relative">
      <HerroSectionAboutUs />
      <SecondSection />
      <CompanyTeamSection />
      <StaffGallery />
      <SectionProjectsList />
    </div>
  );
};

export default AboutCompany;
